import TextStyles from './text_styles';
import TextHeadingStyles from './text_heading_styles';
import ExpandableText from './expandable_text';

const Text = TextStyles;
const TextHeading = TextHeadingStyles;

export { Text, TextHeading, ExpandableText };
